var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03.8-Puzzle-Pieces",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.8.2-Puzzle-Pieces---Correct-Placement",
    transform: "translate(-392.000000, -264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(392.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#202020",
    strokeWidth: 4,
    fill: "#FFFFFF",
    cx: 120,
    cy: 120,
    r: 118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.999809,197.499958 C162.801831,197.499958 197.499624,162.802165 197.499624,120.000143 C197.499624,77.1981211 162.801831,42.5003278 119.999809,42.5003278 C77.1977873,42.5003278 42.499994,77.1981211 42.499994,120.000143 C42.499994,162.802165 77.1977873,197.499958 119.999809,197.499958 Z M103.964081,161.035507 L71.4641584,128.535584 C69.5119536,126.583074 69.5119536,123.416883 71.4641584,121.464373 L78.5353696,114.393467 C80.4878795,112.440957 83.6540707,112.440957 85.6065807,114.393467 L107.499839,136.28703 L154.393038,89.3938317 C156.345853,87.4410166 159.512044,87.4410166 161.464249,89.3938317 L168.53546,96.4647377 C170.487665,98.4172477 170.487665,101.583439 168.53546,103.535949 L111.035597,161.035812 C109.082782,162.988017 105.916896,162.988017 103.964081,161.035507 Z M119.999809,197.499958 C162.801831,197.499958 197.499624,162.802165 197.499624,120.000143 C197.499624,77.1981211 162.801831,42.5003278 119.999809,42.5003278 C77.1977873,42.5003278 42.499994,77.1981211 42.499994,120.000143 C42.499994,162.802165 77.1977873,197.499958 119.999809,197.499958 Z M103.964081,161.035507 L71.4641584,128.535584 C69.5119536,126.583074 69.5119536,123.416883 71.4641584,121.464373 L78.5353696,114.393467 C80.4878795,112.440957 83.6540707,112.440957 85.6065807,114.393467 L107.499839,136.28703 L154.393038,89.3938317 C156.345853,87.4410166 159.512044,87.4410166 161.464249,89.3938317 L168.53546,96.4647377 C170.487665,98.4172477 170.487665,101.583439 168.53546,103.535949 L111.035597,161.035812 C109.082782,162.988017 105.916896,162.988017 103.964081,161.035507 Z",
    id: "ccheck-circle",
    fill: "#74B23B",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2510cb68c532b3a0bcf8a7e1e755b3e6.svg";
export { ForwardRef as ReactComponent };